import getRequestLines from './getRequestLines';
import setRequestLineStatus from './updateRequestLine';

export const SparePartService = {
  getRequestLines,
  setRequestLineStatus,
};
